import React from 'react';
import { Container } from 'reactstrap';
import budget from "./../../assets/STATUSOFSCHEMEWISEBUDGET.pdf";
import { Link } from 'react-router-dom';
const BudgetFinance = () => {
    return (
        <>
        
        <div className="container-fluid px-5 mb-3" >
          
    
          <header className=" mt-3 pt-3">
            <h3>Budget Finance</h3>
    
          </header>
          <section className="content mt-3 pb-3" style={{textAlign:'justify' }}>

             <p><Link to={budget} target='_blank'  className=' text-decoration-none'> STATUS OF SCHEME WISE BUDGET </Link>(Click to Download)</p> 
            </section>
            </div>
            </>
            
    );
};

export default BudgetFinance;
